import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'

import { AssignPlayerOnPitchConfig } from '../../configuration'

export const assignPlayerOnPitchConfig: AssignPlayerOnPitchConfig<BasketballIncidentId> =
  {
    assignPlayerOnPitchIncidents: new Set([
      BasketballIncidentId.FreeThrowIn,
      BasketballIncidentId.TwoPointShotMade,
      BasketballIncidentId.ThreePointShotMade,
      BasketballIncidentId.FourPointShotMade,
    ]),
  }
